export default () => {
  document.addEventListener("DOMContentLoaded", function () {
    const scrollContainer = document.querySelector(".recommendations__table-scroll");
    const sliderContainer = document.getElementById("table-horizontal-slider");
    let sliderInstance = null;

    function initializeSlider() {
      if (!sliderInstance) {
        sliderInstance = noUiSlider.create(sliderContainer, {
          start: 0,
          connect: "lower",
          range: {min: 0, max: 100}
        });

        scrollContainer.addEventListener("scroll", updateSlider);
        sliderInstance.on("update", updateScroll);
      }
    }

    function destroySlider() {
      if (sliderInstance) {
        sliderInstance.destroy();
        sliderInstance = null;
        sliderContainer.innerHTML = "";
        scrollContainer.removeEventListener("scroll", updateSlider);
      }
    }

    function updateSlider() {
      if (sliderInstance) {
        let scrollPercentage = (scrollContainer.scrollLeft / (scrollContainer.scrollWidth - scrollContainer.clientWidth)) * 100;
        sliderInstance.set(scrollPercentage);
      }
    }

    function updateScroll(values) {
      if (sliderInstance) {
        let scrollValue = (values[0] / 100) * (scrollContainer.scrollWidth - scrollContainer.clientWidth);
        scrollContainer.scrollLeft = scrollValue;
      }
    }

    function checkScreenSize() {
      if (window.innerWidth <= 768) {
        sliderContainer.style.display = "block";
        initializeSlider();
      } else {
        sliderContainer.style.display = "none";
        destroySlider();
      }
    }

    checkScreenSize();
    window.addEventListener("resize", () => {
      destroySlider();
      checkScreenSize();
    });
  });
};

